module.exports = __webpack_public_path__ + "yellow-line-1.svg?bc333586bc3204ce2f5f72f0896c1a97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow-line-1.svg
// module id = 393
// module chunks = 0